export default __webpack_public_path__ + "static/media/message-in.b798c356.mp3";